/**
 * Created by M on 2018/3/29.
 */

var getWidthByText = function (singleText) {
  if (singleText) {
    return 50 + singleText.length * 12;
  }
  return 50;
}

var singleCol = function (singleSelectTypeIcon, singleSelectText, handleEdit) {
  return {
    width: getWidthByText(singleSelectText),
    key: "singleSelect",
    align: 'center',
    render: (h, params) => {
      return (
        <a href="javascript:void(0)" onClick={() => handleEdit(params.index, params.row)}>
          <i class={singleSelectTypeIcon} style="font-size:14px;"></i>  {singleSelectText}
        </a>
      )
    }
  }
};

var multipleCol = {
  key: "selection",
  type: 'selection',
  width: 60,
  align: 'center'
};

var actionCol = function (actions, handleCommand) {
    return {
      width: 100,
      key: "action",
      align: 'center',
      render: (h, params) => {
        var dropItems = [];
        actions.forEach(act => {
          if (act.visible) {
            if (!act.visible(params.row)) {
              return;
            }
          }

          dropItems.push((
            <dropdown-item name={act.actionId} placement="right-end">
              <i-button type="text" size="small" on-click={() => handleCommand(act.actionId, params.row)}><i
                class={act.icon}></i> {act.display}
              </i-button>
            </dropdown-item >));
        });


        return (
          <dropdown trigger="click" transfer>
            <a href="javascript:void(0)">
              操作 <i class="el-icon-caret-bottom el-icon--right"></i>
            </a>
            <dropdown-menu slot="list" >
              {dropItems}
            </dropdown-menu>
          </dropdown>
        )
      }
    }
  }
;


export {
  singleCol, multipleCol, actionCol
}



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/basicElement/table/customCols.js